<template>
	<transition name="fade" appear @before-enter="beforeEnter" @before-appear="beforeEnter" @after-leave="afterLeave" @after-appear="afterLeave">
		<div class="my-popup" v-if="vIf" v-show="vShow" :style="style" @click.stop="close('modal')">
			<div class="my-update" v-if="uShow && updateDuration > 0" @animationend="uShow = false" :style="{ animationDuration: updateDuration + 'ms', backgroundColor: 'transparent' }">
            	<i :style="{ backgroundColor: updateColor }"></i>
            	<i :style="{ backgroundColor: updateColor }"></i>
            	<i :style="{ backgroundColor: updateColor }"></i>
            	<i :style="{ backgroundColor: updateColor }"></i>
            	<i :style="{ backgroundColor: updateColor }"></i>
            </div>
            <slot></slot>
		</div>
	</transition>
</template>

<script>
	// fixed
	export default {
		name: 'my-popup',
		props: {
			// 是否更新动画:visible.update
			update: {
				type: Boolean,
				default: true
			},
			// 是否显示:visible.sync
			visible: {
				type: Boolean,
				default: false
			},
			// 弹窗的整体及overlay的样式
			modalStyle: {
				type: Object,
				default: function() {
					return {
						// 只接收zIndex、backgroundImage、backgroundColor3个属性
						// zIndex: 1000,
						// backgroundImage: 'url()'
						// backgroundColor: 'rgba(0, 0, 0, 0.5)'
					};
				},
				validator: function(value = {}) {
					return value;
				}
			},
            // 更新图标颜色
            updateColor: {
				type: String,
				default: '#000000'
            },
            // 更新图标显示时长
            updateDuration: {
				type: Number,
				default: 750
            },
			// 关闭前的回调，会暂停 Dialog 的关闭
			beforeClose: Function,
			// 关闭弹窗时销毁 Dialog 中的元素
			destroyOnClose: {
				type: Boolean,
				default: false
			},
			// 是否可以通过点击 modal 关闭 Dialog
			closeOnClickModal: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				vIf: false,
				vShow: false,
				uShow: false,
				bodyOriginalOverflow: '',
				modalBackgroundColor: this.backgroundColor || 'rgba(0, 0, 0, 0.5)'
			}
		},
		watch: {
			uShow: {
				handler(newValue) {
					if (newValue === false) {
						this.$emit('update:update', false);
					}
				}
			},
			update: {
				handler(newValue) {
					this.uShow = newValue;
				},
				immediate: true
			},
			visible: {
				handler(newValue) {
					if (newValue) {
						this.vIf = true;
						this.vShow = true;
					} else {
						this.vShow = false;
					}
				},
				immediate: true
			},
			childVisible: {
				handler(newValue) {
					if (newValue) {
						this.modalBackgroundColor = 'transparent';
					} else {
						this.modalBackgroundColor = this.backgroundColor || 'rgba(0, 0, 0, 0.5)';
					}
				},
				immediate: true
			}
		},
		methods: {
			beforeEnter() {
                // console.log('显示', this.visible, this.$parent.$options.name)
                if (this.visible) {
					document.body.classList.add('show-my-dialog-body-overflow-hidden');
                    // this.bodyOriginalOverflow = document.body.style.overflow;
                    // document.body.style.overflow = 'hidden';
                }
				// this.bodyOriginalOverflow = document.body.style.overflow;
				// document.body.style.overflow = 'hidden';
			},
			afterLeave() {
                // console.log('隐藏', this.visible, this.$parent.$options.name)
                if (this.visible === false) {
					document.body.classList.remove('show-my-dialog-body-overflow-hidden');
                    // document.body.style.overflow = this.bodyOriginalOverflow;
                    // this.bodyOriginalOverflow = '';
                    if (this.destroyOnClose) {
                    	this.vIf = false;
                    }
                }
				// document.body.style.overflow = this.bodyOriginalOverflow;
				// this.bodyOriginalOverflow = '';
				// if (this.destroyOnClose) {
				// 	this.vIf = false;
				// }
			},
			async close(status) {
				if ((status === 'modal') && (this.closeOnClickModal === false)) {
					return false;
				}
				let result = true;
				if (this.beforeClose && (typeof this.beforeClose === 'function')) {
					result = await this.beforeClose(status);
				}
				if (result) {
					this.$emit('update:visible', false);
					this.$emit('close', status);
				}
			}
		},
		computed: {
			style() {
				let style = '';
				if (this.modalStyle.zIndex) {
					style += `z-index: ${this.modalStyle.zIndex};`;
				}
				if (this.backgroundImage) {
					style += `background-image: ${this.backgroundImage};`;
				} else {
					style += `background-color: ${this.modalBackgroundColor};`;
				}
				return style;
			},
			backgroundImage() {
				return this.modalStyle.backgroundImage || '';
			},
			backgroundColor() {
				return this.modalStyle.backgroundColor || 'rgba(0, 0, 0, 0.5)';
			}
        }
	}
</script>

<style>
    .show-my-dialog-body-overflow-hidden{
        overflow: hidden;
    }
</style>

<style scoped lang="less">
	.my-popup{
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 50%;
		left: 50%;
		z-index: 1000;
		display: flex;
		align-items: center;
		justify-content: center;
		transform: translate(-50%, -50%);
		background-color: rgba(0, 0, 0, 0.75);
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
        .my-update{
            position: absolute;
            top: 0;
            left: 0;
            opacity: 1;
            z-index: 99;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            pointer-events: auto;
            justify-content: center;
            // background-color: inherit;
            // animation-duration: 500ms;
            animation-delay: 0ms;
            animation-name: fade-update;
            animation-fill-mode: forwards;
            animation-timing-function: linear;
            i{
                display: inline-block;
                width: 10px;
                height: 10px;
                margin-right: 5px;
                border-radius: 50%;
                // background-color: #FFFFFF;
                animation: loading 1.04s ease infinite;
                &:nth-child(1){
                    animation-delay: 0.13s;
                }
                &:nth-child(2){
                    animation-delay: 0.26s;
                }
                &:nth-child(3){
                    animation-delay: 0.39s;
                }
                &:nth-child(4){
                    animation-delay: 0.52s;
                }
                &:nth-child(5){
                    margin-right: 0px; 
                    animation-delay: 0.65s;
                }
            }
            @keyframes loading{
                0%{
                    opacity: 1;
                }
                100%{
                    opacity: 0;
                }
            }
            @keyframes fade-update{
            	0%, 100%{
            		opacity: 0;
            		transform: scale(1.1);
            	}
            	20%, 80%{
            		opacity: 1;
            		transform: scale(1.0);
            	}
            }
        }
		.container-scroll-y{
			overflow-x: hidden;
			overflow-y: scroll;
			scrollbar-width: none;
			scrollbar-color: transparent transparent;
			&::-webkit-scrollbar{
				width: 0px;
			}
			&::-webkit-scrollbar-thumb{
				border-radius: 0px;
				background-color: transparent;
			}
			&::-webkit-scrollbar-button{
				display: none;
			}
			&::-webkit-scrollbar-track{
				background-color: transparent;
			}
		}
	}
	.fade-enter-active{
		pointer-events: auto;
		animation: fade 300ms ease-in forwards;
	}
	.fade-leave-active{
		pointer-events: none;
		animation: fade 300ms ease-in forwards reverse;
	}
	@keyframes fade{
		0%{
			opacity: 0;
			transform: translate(-50%, -50%) scale(1.1);
		}
		100%{
			opacity: 1;
			transform: translate(-50%, -50%) scale(1.0);
		}
	}
</style>
